/**
 * Implementation of ChatService using Zendesk
 *
 * Handles adding zendesk script tag, initial configuration, and exposes methods for interacting with chat component.
 *
 * @param (bool) isEnabled If false, script will not be loaded, and methods will do nothing.
 * @param (string) key Which zendesk key to use with the script tag.
 */
export default class ZendeskChatService {

  constructor({ key }) {
    this.key = key;
    loadScript({ key: this.key });
  }

  /**
   * Shows chat component.
   */
  async show() {
    await loadScript({ key: this.key });
    zE('messenger', 'show');
  }

  async open() {
    await loadScript({ key: this.key });
    zE('messenger', 'open');
  }

  /**
   * Hides chat component.
   */
  async hide() {
    await loadScript({ key: this.key });
    zE('messenger', 'hide');
  }

}

// private functions

let _loadScriptPromise = null;

function loadScript({ key }) {
  if (_loadScriptPromise) {
    return _loadScriptPromise
  }

  _loadScriptPromise = new Promise((resolve, reject) => {
    try {
      addScript({
        key,
        onload: () => {
          initialize();
          resolve();
        },
      });
    } catch (e) {
      console.warn(e);
      reject(e)
    }
  });

  return _loadScriptPromise
}

function addScript({ key, onload }) {
  if (document.getElementById('ze-snippet')) {
      return;
  }

  let script = document.createElement('script');
  script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${key}`)
  script.setAttribute('id', "ze-snippet");
  script.async = true;
  script.onload = onload;
  document.head.appendChild(script);
}

function initialize() {
  zE('messenger:set', 'cookies', true); // enable persistence of chats
  zE('messenger', 'hide'); // hide by default
  zE('messenger:set', 'zIndex', 1006); // must be below modals
}
